<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ filtro.name }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <MultiSelect
    v-else
    :label="filtro.name"
    :campos="clientes"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    :buscaRemota="true"
    :buscando="buscando"
    @atualizar="atualizar"
    @buscar="buscarClientes"
  />
</template>
<script>
import MultiSelect from '../../components/MultiSelect.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      clientes: [],
      loading: true,
      buscando: false,
      termoAtual: ''
    }
  },
  components: {
    MultiSelect
  },
  methods: {
    atualizar(selecionados) {
      this.$aplicaFiltroEmURL(this.filtro.filtro, selecionados, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: selecionados
      });
    },
    buscarClientes(term = '') {
      const { parametros } = this.filtro;
      const paramsDefault = { params: { tipos: ['cliente'] } };
      if (parametros && typeof parametros === 'object') {
        paramsDefault.params = { ...paramsDefault.params, ...parametros };
      }
      this.buscando = true;
      this.termoAtual = term;
      this.$api.get('/stakeholders/busca_todos', { params: { ...paramsDefault.params, term } }).then(response => {
        if (this.termoAtual !== term) return;
        const stakeholders = response.data;
        this.clientes = stakeholders.map(stakeholder => ({
          id: stakeholder.id,
          name: stakeholder.label
        }));
      }).catch(error => {
        if (this.termoAtual !== term) return;
        console.error('Erro ao buscar clientes:', error);
      }).finally(() => {
        if (this.termoAtual === term) {
          this.buscando = false;
          this.loading = false;
        }
      });
    },
  },
  mounted() {
    this.buscarClientes();
  }
}
</script>
